import React from 'react';
import './OrderSummery.css';
const OrderSummery = ({ windowDimensions, trackData }) => {
    const totalPrice = trackData && trackData?.requestProduct?.reduce(
        (total, prd) => total + (parseInt(prd.price) * prd.orderQuantity), 0);
    return (
        <div className='order-summery'>
            <div className="row">
                <div className="col-12 col-md-8 col-sm-7 col-lg-9">
                    <h6>Items Details ({trackData?.requestProduct?.length} item)</h6>
                </div>
                {
                    windowDimensions?.width > 575 && <>
                        <div className="col-md-2 text-center col-sm-2 col-lg-1">
                            <h6>Quantity</h6>
                        </div>
                        <div className="col-md-2 text-center col-sm-3">
                            <h6>Amount</h6>
                        </div>
                    </>
                }

            </div>
            <hr />
            {
                trackData && trackData?.requestProduct?.map((item, index) => (
                    <div key={index}>
                        <div className="row" key={index}>
                            <div className="col-12 col-sm-3 col-lg-2 col-xl-2 product-img-blcok">
                                <img src={item.url} className='w-100 product-img' alt="" />
                            </div>
                            <div className="col-12 col-sm-9 col-lg-10 product-content">
                                <div className="row">
                                    <div className="col-12 col-md-8 col-sm-7 col-lg-9 product-content-body">

                                        <h5 className='pd-title'>
                                            {windowDimensions?.width < 576 ? `Title: ${item.name}` : `${item.name}`}
                                        </h5>
                                        <h5 className='pd-price'>
                                            {windowDimensions?.width < 576 ? `Price: ৳${item.price}` : `৳${item.price}`}</h5>
                                    </div>
                                    <div className="col-12 col-md-2 col-sm-1 col-lg-1 qty-block">
                                        <h5 className='pd-qty '>
                                            {windowDimensions?.width < 576 ? `Quantity: ${item.orderQuantity}` : `${item.orderQuantity}`}
                                        </h5>
                                    </div>
                                    {
                                        windowDimensions?.width > 575 && <div className="col-12 col-md-2 col-sm-3 col-lg-2">
                                            <h5 className='pd-total'>৳{parseInt(item.price) * parseInt(item.orderQuantity)}</h5>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <br />
                        <hr />
                    </div>
                ))

            }
            <div className="row">
                <div className="col-6 col-md-10 text-end col-sm-6  font-weight-bold">
                    <h6 style={{fontWeight: 'bolder'}}>Total Price: </h6>
                </div>
                <div className="col-6 col-md-2 text-center col-sm-6 font-weight-bold">
                    <h6 style={{fontWeight: 'bolder'}}>৳{totalPrice}</h6>
                </div>

            </div>
        </div>
    );
};

export default OrderSummery;